<template>
    <rkm-area
        background-color="danger"
        closed
        header-prefix-text="S"
        title="Subjetivo"
        type="box"
    >
        <rkm-row>
            <rkm-col cols="12">
                <strong>Impressões subjetivas do profissional e as expressadas pelo paciente</strong><br><div v-html="formatDescricao(item.subjetivo.descricao)"></div>
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col cols="12">
                <BoxMotivoAtendimento
                    v-if="!item.isAtendimentoSaudeBucal"
                    :item="item"
                />
            </rkm-col>
        </rkm-row>
    </rkm-area>
</template>

<script>
// Components.
import BoxMotivoAtendimento from './components/motivo-atendimento/Index'

export default {
    components: {BoxMotivoAtendimento},
    props: {
        item: {type: Object, required: true},
    },
    methods: {
        formatDescricao(descricao) {

            if (descricao) {
                return descricao.replace(/\n/g, '<br>');
            }

            return null
        },
    }
}
</script>